import script from "./PageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBanner.vue?vue&type=script&setup=true&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=ab72870e&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab72870e"]])

export default __exports__